export default __webpack_public_path__ + "static/media/IconDesc_CateriumIngot.256.d014d83a.png";